import { createSelector } from 'reselect'

const getLessonSession = state => state.lessonSession

export default createSelector(
	[ getLessonSession ],
	session => session
)
